import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'
import {Row, Col} from 'react-flexbox-grid'
import Helmet from 'react-helmet'
import Loader from 'react-loader'
import {Doughnut} from 'react-chartjs'
import {SlideDown} from 'react-slidedown'
import config from '../../config'
import container from '../../helpers/container'
import format from '../../helpers/format'
import {
  ContainerDivs,
  Link,
  LinkIcon,
  Grade,
  XsBr
} from '../../components'
import * as searchActions from 'redux/modules/search'
import Styles from './TspLanding.css'
import imageSocialShare from '../../../static/images/tsp-social-share.jpg'


@CSSModules(Styles, { allowMultiple: true })
class TspStarsBar extends Component {
  render() {
    return <div styleName='tsp-lede-stars' />
  }
}


@CSSModules(Styles, { allowMultiple: true })
class TspLede extends Component {
  static propTypes = {
    roundToBillions: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
  }

  render() {
    // const aysLogo = require( '../../../static/images/AsYouSow_Logo_color.svg' )
    //
    return <div styleName='lede-wrap-outer'>
      <div styleName='lede-wrap'>
        <div styleName='lede-xs-graphic visible-xs'/>
        <ContainerDivs>

          <h1 styleName='lede-h1'>
            The Thrift Savings Plan has
            <span styleName='lede-h1-strong hidden-xs'>
              { this.props.roundToBillions(config.tspHoldingStats.ff_all_asset) }
            </span>

            <span styleName='lede-h1-strong visible-xs'>
              { this.props.roundToBillions(config.tspHoldingStats.ff_all_asset, false, true) }
            </span>
            in fossil fuel stocks
          </h1>

          <div styleName='lede-p-wrap'>
            <p>
              The Federal Thrift Savings Plan (TSP) manages over $725
              billion in retirement savings for 6 million federal
              employees.

              It's putting those savings
              into coal, oil, and gas companies that are
              driving the climate crisis.
            </p>

            <p>
              If the TSP continues to ignore climate change,
              plan participants could face financial losses
              from stranded assets and other climate-related
              financial risks.
            </p>
          </div>
        </ContainerDivs>
      </div>
      <TspStarsBar />
    </div>
  }
}


@CSSModules(Styles, { allowMultiple: true })
class TspBanner extends Component {
  render() {
    return <div>
      <TspStarsBar />
      <div styleName='banner-wrap'>
        <ContainerDivs>

          <p styleName='banner-copy'>
            Extreme weather like wildfires, floods, droughts,
            and storms have tripled in the last 30 years.

            Economists say climate change
            could cause the <span styleName='banner-red'>next
            great financial crisis.</span>
          </p>

          <p styleName='banner-copy'>
            We can't meet the goals of the Paris Climate
            Agreement and limit global warming to 1.5˚C
            while expanding coal, oil, and gas.

            We need climate justice now, and we need the
            Thrift Savings Plan to do more.
          </p>

          <div styleName='banner-cta'>
            <h3>
              How retirement plans fuel the climate crisis
            </h3>
            <div>
              <Link
                to={'https://investyourvalues.org/the-issues/fossil-fuels'}
                title='Asset managers are investing in the climate crisis'
              >
                <span styleName='banner-cta-btn'>
                  Learn More
                </span>
              </Link>
            </div>
          </div>

        </ContainerDivs>
      </div>
      <TspStarsBar />
    </div>
  }
}


@CSSModules(Styles, { allowMultiple: true })
class TspPieChart extends Component {
  static propTypes = {
    roundToBillions: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
  }

  render() {
    return <ContainerDivs>
      <div styleName='tsp-pie-wrap'>
        <div styleName='tsp-pie-content'>
          <h2 styleName='tsp-pie-h2'>
            {format.perc(config.tspHoldingStats.oil_majors[1])} of
            TSP fossil fuel investments are
            in <strong styleName='tsp-pie-h2-strong'>10 oil & gas
            majors</strong>
          </h2>
          <table styleName='oil-majors-table'>
            <thead>
              <tr>
                <th/>
                <th>$USD invested</th>
                <th>% of fossil fuel investments</th>
              </tr>
            </thead>
            <tbody>
              {
                config.tspHoldingStats.oil_majors[2].map((e, i)=>{
                  const p = format.perc(e[1] / config.tspHoldingStats.ff_all_asset)
                  const a = this.props.roundToBillions(e[1], false, true)
                  return <tr key={'li-oil-major-'+i}>
                    <td>{e[0]}</td>
                    <td>{a}</td>
                    <td>{p}</td>
                  </tr>
                })
              }
              <tr>
                <td><b>Total</b></td>
                <td><b>{this.props.roundToBillions(config.tspHoldingStats.oil_majors[0], false, true)}</b></td>
                <td><b>{format.perc(config.tspHoldingStats.oil_majors[1])}</b></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div styleName='doughnut-wrap'>
          <Doughnut
            data={[
              {
                value: config.tspHoldingStats.oil_majors[1],
                label: 'Top 10 Oil Majors: ' + format.perc(config.tspHoldingStats.oil_majors[1]),
                color: '#821400'
              },
              {
                value: config.tspHoldingStats.og[1] - config.tspHoldingStats.oil_majors[1],
                label: 'Other Oil & Gas: ' + format.perc(config.tspHoldingStats.og[1] - config.tspHoldingStats.oil_majors[1]),
                color: '#D2371B'
              },
              {
                value: config.tspHoldingStats.ut[1],
                label: 'Utilities: ' + format.perc(config.tspHoldingStats.ut[1]),
                color: '#A95C0B'
              },
              {
                value: config.tspHoldingStats.other[1],
                label: 'Other: ' + format.perc(config.tspHoldingStats.other[1]),
                color: '#333'
              },
            ]}
            options={{
              animation: false,
              segmentStrokeWidth: 0,
              percentageInnerCutout: 0,
              // animationEasing: 'easeOutQuad',
              // String - Template string for single tooltips
              // tooltipTemplate: "<%if (label){%><%=label %>: <%}%><%= value + ' %' %>",
              tooltipTemplate: '<%=label %>',
              // String - Template string for multiple tooltips
              multiTooltipTemplate: "<%= value + ' %' %>",
              onAnimationComplete: function(){
                this.showTooltip(this.segments, true);
              },
              tooltipEvents: [],
              showTooltips: true
            }}
            width='350'
            height='350'
          />
          <p styleName='tsp-pie-chart-disclaimer'>
            {this.props.roundToBillions(config.tspHoldingStats.ff_all_asset, false)}B
            in Thrift Savings Plan fossil fuel investments
            by industry. "Other" includes coal mining
            and conglomerates with
            carbon reserves and/or
            fossil fuel operations.
          </p>
        </div>
      </div>
    </ContainerDivs>
  }
}


@CSSModules(Styles, { allowMultiple: true })
class TspCompanyCharts extends Component {
  static propTypes = {
    roundToBillions: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)
  }

  render() {
    const icons = {
      'og': require('../../../static/images/tsp-og-bg.jpg'),
      'ut': require('../../../static/images/tsp-ut-bg.jpg')
    }
    return <div>
      {
        [
          ['og', 'oil & gas companies',
           'oil & gas industry'],
          ['ut', 'fossil-fired utilities',
           'fossil-fired utility'],
        ].map((c, i)=>{
          return <div>
            <div key={'tsp-chart-'+i} > { /* styleName={'tsp-chart-wrap-'+c[0]} */ }
              <ContainerDivs>
                <div styleName='tsp-company-chart-rel'> { /* Row */ }
                  <div styleName='tsp-company-chart-bg'>  { /* Col xs={12} sm={12} md={6} lg={6} */ }
                    { /* CHART HEADER GOES HERE */ }
                    <div styleName='tsp-company-chart-header'>
                      <h2>
                        <strong styleName={c[0]}>
                          { this.props.roundToBillions(config.tspHoldingStats[c[0]][0], false, true) }
                          { /* this.props.roundToBillions(config.tspHoldingStats[c[0]][0]) */ }
                          &nbsp;
                        </strong>
                        in {c[1]}
                      </h2>
                      <h3>
                        Top 10 {c[2]} investments in Thrift Savings Plan funds
                      </h3>
                    </div>
                    { /* CHART GOES HERE */ }
                    <div styleName='tsp-company-bar-wrap'>
                      {
                        config.tspHoldingStats[c[0]][2].map((e, i2)=>{
                          const w = (e[1] / config.tspHoldingStats.og[2][0][1])
                          //
                          return <div
                            styleName='bar-chart-row'
                            key={'bar-chart-row-'+i+'-'+i2}
                          >
                            <Row>
                              <Col xs={12} sm={3}>
                                <div styleName='bar-chart-label'>
                                  {e[0]}
                                </div>
                              </Col>
                              <Col xs={12} sm={9}>
                                <div styleName='bar-chart-bar-wrap'>
                                  <div
                                    styleName={'bar-chart-bar-'+c[0]}
                                    style={{
                                      'width': (w * 100 * 0.8) + '%'
                                    }}
                                  />
                                  <span styleName='bar-chart-figure'>
                                    { this.props.roundToBillions(e[1], false, true) }
                                  </span>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        })
                      }
                    </div>

                    <img
                      src={icons[c[0]]}
                      alt='tmp'
                      styleName='tsp-company-chart-img'
                    />
                  </div>
                </div>
              </ContainerDivs>
            </div>
          </div>
        })
      }
    </div>
  }
}


@CSSModules(Styles, { allowMultiple: true })
class TspAssetManagers extends Component {
  render() {
    return <div styleName='am-banner-wrap'>
      <ContainerDivs>
        <div styleName='am-banner-inner'>
          <div styleName='am-banner-content-wrap'>

            <h2 styleName='am-banner-h2'>
              BlackRock and State Street are failing their responsibility of prudent and loyal stewardship
            </h2>

            <p>
              A significant proportion of TSP fund assets are managed by
              BlackRock and State Street, who routinely vote these shares
              according to their own investment policies.
            </p>

            <p>
              Last year, BlackRock <Link
                to='https://www.reuters.com/business/finance/blackrock-continues-lowering-support-environmental-social-proposals-2023-08-23/'
                title='BlackRock continues lowering support for environmental and social proposals'
              >opposed 93%</Link> of shareholder proposals
              related to climate change or social issues, up from
              78% the year before, and 53% the year before that.
            </p>

            <p>
              State Street isn't much different. Research shows how
              both State Street and BlackRock support the status quo
              at climate-critical companies,
              voting in favor of boards of
              directors <Link
                to='https://www.majorityaction.us/climate-in-the-boardroom-2022'
                title='Climate in the Boardroom: How Asset Manager Voting Shaped Corporate Climate Action in 2022'
              >over 95% of the time.</Link>
            </p>

            { /* TSP shares are voted in a way that minimizes climate-related financial risk */ }

          </div>
        </div>
      </ContainerDivs>
    </div>
  }
}


@CSSModules(Styles, { allowMultiple: true })
class TspFundItem extends Component {
  static propTypes = {
    fund: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
  }

  getShareclassUrl(shareclass){
    // const A = `${config.domain}`
    const B = `${config.routes.fund}/`
    const C = `${format.sanitize(shareclass.fund_legal_name)}/`
    const D = 'N/'
    const E = `${config.profilePath}/`
    const F = `${shareclass.fund_id}/`
    const G = `${shareclass.investment_vehicle_id}/`

    return `${B}${C}${D}${E}${F}${G}`
  }

  render() {
    if (!this.props.fund) { return null }
    const e = this.props.fund
    if (!e.grade_fossil) {
      return (
      <div styleName='tsp-fund-item-inactive'>
        { e.fund_legal_name === 'L Income' ?
            e.fund_legal_name :
            e.fund_legal_name.slice(4,10)
        } <div styleName='tsp-inactive-asterisk'>*</div>
      </div>
      )
    }
    return (
      <Link
        to={this.getShareclassUrl(e)}
        title={e.fund_legal_name}
      >
        <div styleName='tsp-fund-item'>
          {e.fund_legal_name.slice(4,10)}
          <div styleName='tsp-fund-item-grade'>
            <span>{format.perc(e.c2f5coogutweight)}</span>
            <Grade grade={e.grade_fossil} blocksmall/>
          </div>

        </div>
      </Link>
    )
  }
}


@CSSModules(Styles, { allowMultiple: true })
class TspRecommendations extends Component {
  render() {
    return <div>
      <div styleName='anchor' id='recommendations' />
      <TspStarsBar />
      <div styleName='tsp-recs-wrap'>
        <ContainerDivs>
          <div styleName='tsp-recs-content'>
            <h2>
              What can the TSP do?
            </h2>
            <p>
              The TSP is required to by law to track certain indices. But there
              are steps the plan could take to safeguard workers' savings.
            </p>
            <ul>
              <li>
                <p>
                  <b>AUDIT:</b> Perform and publish a rigorous audit of the
                  TSP's exposure to climate-related financial risk.
                </p>
              </li>
              <li>
                <p>
                  <b>ENGAGE:</b> Engage TSP fund managers like BlackRock and
                  State Street Global Advisors on climate risk-related
                  proxy voting policies.
                  Engage TSP index providers like S&P Global and MSCI to take
                  climate risk into account in index management.
                </p>
              </li>
              <li>
                <p>
                  <b>EDUCATE:</b> Ensure employees are aware of the risk that
                  climate change poses to their retirement savings.
                </p>
              </li>
            </ul>
          </div>
        </ContainerDivs>
      </div>
    </div>
  }
}


@CSSModules(Styles, { allowMultiple: true })
class TspSolutionsTakeAction extends Component {
  render() {
    return <div>
      <TspStarsBar />
      <div styleName='solutions-take-action-wrap'>
        <ContainerDivs>
          <Row>
            {
              [
                ['The solutions',
                  `Learn about sustainable investing solutions and best
                   practices
                  `,
                  'https://investyourvalues.org/the-solutions'],
                ['Take action',
                  `Visit our employee resources center and learn how to
                   invest in a sustainable future
                  `,
                  config.routes.tspToolkit],
                ['Self-directed option',
                  `Search thousands of funds to find fossil free
                  alternatives through the TSP's self-directed option
                  `,
                  config.routes.list],
              ].map((e, i)=>{
                const icon = require(`../../../static/images/tsp-icon-circle-${i+1}.png`)
                return <Col xs={12} sm={4} key={'tsp-col-'+i}>
                  <div styleName={'tsp-col-'+i}>
                    <Link
                      to={e[2]}
                      title={e[0]}
                    >
                      <img src={icon} alt={e[0]}/>
                      <h3 styleName='tsp-col-h3'>
                        {e[0]}
                      </h3>
                      <div styleName='tsp-col-copy'>
                        {e[1]}
                      </div>
                    </Link>
                  </div>
                </Col>
              })
            }
          </Row>
        </ContainerDivs>
      </div>
    </div>
  }
}


@CSSModules(Styles, { allowMultiple: true })
class TspFAQs extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: {},
      faqs: [
        [
          <span>
            Can the TSP add new climate-safe fund options?
          </span>,
          <span>
            <Link
              to='https://www.law.cornell.edu/uscode/text/5/8438'
              title='5 U.S. Code § 8438 - Investment of Thrift Savings Fund'
            >By law,</Link> the TSP is constrained to offering a small set of funds that track "commonly recognized" indices with "reasonably complete" market representation, weighted by market capitalization. Absent the introduction of a climate-safe index that meets these standards, TSP is effectively precluded from adding new climate-safe sustainable fund options without action from Congress. Some members of Congress have introduced legislation that would allow the TSP to add climate-safe options. Because the TSP faces such legal restrictions, it’s all the more important that the plan take action to audit, engage, and educate on climate risk.
          </span>,
        ],
        [
          <span>
            Does the TSP have a self-directed option with climate-safe funds?
          </span>,
          <span>
            In 2022, the TSP added a <Link
            to='https://www.tsp.gov/mutual-fund-window/'
            title='Mutual Fund Window | Thrift Savings Plan'
            >"mutual fund window",</Link> also known as a self-directed option. This gives plan participants access to a wider range of fund options, including climate-safe sustainable funds. But the window comes with higher fees, limits on who can use it, and limits on how much can be invested. More broadly, plans that offer self-directed options usually see only between 1 and 2% of plan assets invested through them. Self-directed retirement options shift the practical responsibility for risk management from the plan to the participant. At best, it’s a band-aid that doesn’t address the climate risk facing the vast majority of the plan's assets.
          </span>,
        ],
        [
          <span>
            Can the TSP vote in favor of climate-related shareholder proposals?
          </span>,
          <span>
            <Link
              to='https://www.law.cornell.edu/uscode/text/5/8438'
              title='5 U.S. Code § 8438 - Investment of Thrift Savings Fund'
            >By law,</Link> the TSP is not allowed to directly vote on
            shareholder proposals or for boards of directors at the companies it invests in. But a significant proportion of its fund assets are managed by BlackRock and State Street, who routinely vote the shares associated with TSP funds according to their own investment policies. There’s nothing stopping the Federal Retirement Thrift Investment Board (FRTIB), the officials responsible for managing the TSP, from engaging these asset managers on their proxy voting guidelines. In fact, FRTIB’s fiduciary duty compels it to review these guidelines to ensure they are in participants’ best interests.
            Last year, <Link
              to='https://www.bloomberg.com/news/articles/2023-08-23/blackrock-backs-fewer-climate-social-shareholder-proposals#xj4y7vzkg'
              title='BlackRock Backs Fewer Climate, Social Shareholder Proposals'
            >BlackRock opposed 93%</Link> of shareholder proposals related to climate change or social issues. State Street isn't much different. The FRTIB should engage these managers to ensure that TSP shares are voted in a way that minimizes climate-related financial risk.
          </span>,
        ],
        [
          <span>
            What role do BlackRock and State Street play?
          </span>,
          <span>
            BlackRock and State Street manage the $725 billion invested in the TSP, following the guidelines set by the law and the Federal Retirement Thrift Investment Board. As asset managers, they have a responsibility to act as prudent and loyal stewards of their clients’ assets.
            But BlackRock and State Street <Link
              to='https://www.majorityaction.us/climate-in-the-boardroom-2022'
              title='Climate in the Boardroom: How Asset Manager Voting Shaped Corporate Climate Action in 2022'
            >often fail in this responsibility,</Link> opposing the vast
            majority of shareholder proposals related to climate change, and refusing to hold boards of directors to account for inaction on addressing climate risk. These asset managers should update their proxy voting policies to reflect an intention that proxy voting be aligned to the goal of limiting global temperature rise to 1.5°C, and the expectation that portfolio companies will take action on emissions consistent with a 1.5°C pathway, including target setting and capital allocation.
          </span>,
        ],
        [
          <span>
            What steps have other retirement savings systems taken to protect from climate risk?
          </span>,
          <span>
            Some <Link
              to='https://www.bloomberg.com/news/features/2022-10-20/how-to-purge-fossil-fuel-investments-from-your-401-k-or-ira#xj4y7vzkg'
              title='What’s in Your 401(k)? Polluters Driving Climate Change'
            >1,500 institutions</Link> representing more than $40 trillion in assets have committed to reducing exposure to investments in high-carbon industries. This includes retirement savings systems: The University of California (UC) removed all companies that own fossil fuel reserves from the <Link
              to='https://myucretirement.com/Resource/2312'
              title='Changes to the UC Retirement Savings Program (RSP) fund offerings'
            >UC Retirement Savings Program</Link> on the basis that “the fossil fuel industry faces considerable long term financial risk” and that removing such companies “will have a positive financial and risk-reducing impact on fund performance in the long run.” But many 401(k)s are still directing employee savings to climate-risky investments by default. Retirement savers first need access to sustainable fund options, and ultimately, sustainability should become the standard. (Our  <Link
              to='https://investyourvalues.org/'
              title='Retirement Plan Sustainability Scorecard | Invest Your Values'
            >401(k) Scorecard</Link> tracks close to 50 employer-offered retirement
            plans.)
          </span>,
        ],
        [
          <span>
            What is climate-related investment risk?
          </span>,
          <span>
            Climate change is accelerating, resulting in a growing number of climate-related natural disasters, and the economic impacts are becoming increasingly evident. Climate-related investment risk is the risk that the economic impacts of climate change will cause your investments to suffer losses. <i>Physical climate change risk</i> is the threat to asset prices posed by emissions-fueled disasters such as flooding, wildfires, or hurricanes. Companies also face <i>transition risk</i> as we shift towards a clean energy economy. Achieving decarbonization of the world economy requires a transition away from carbon-based energy, which will necessarily alter some companies’ businesses. High-carbon industries face some of the most significant physical and transition risks, and addressing climate-related investment risk usually involves carefully scrutinizing investments in these sectors.
          </span>,
        ],
        [
          <span>
            Where did you get this data?
          </span>,
          <span>
            This analysis applies our Fossil Free Funds rating methodology
            to the TSP fund options. The TSP does not publish fund holdings,
            but each of the individual equity funds tracks a commonly-used index, tracked
            by many index funds. For the individual funds, we used a matching
            index fund as a stand-in. The L funds are made up of
            varying proportions of the individual equity and
            fixed-income funds (C, S, I, F, and G funds). For these target date funds, we used
            allocation data from the <Link
              to='https://www.tsp.gov/funds-lifecycle/'
              title='Lifecycle funds | Thrift Savings Plan'
            >TSP.gov website</Link> to model each portfolio
            using the individual fund analyses.
            We used assets-under-management to calculate
            figures like overall fossil fuel investments.
            See our full <Link
              to={config.routes.howitworks}
              title='How it works | Fossil Free Funds'
            >Fossil Free Funds methodology here.</Link> A detailed analysis
            of the TSP funds <Link
              to={'https://investyourvalues.org/retirement-plans/thrift-savings-plan'}
              title='Thrift Savings Plan | 401(k) Scorecard | Invest Your Values'
            >across multiple environmental
            and social issues is here.</Link>
          </span>,
        ],
      ]
    }
  }

  render() {
    return <div styleName='tsp-faq-wrap'>
      <ContainerDivs>
        <Row>
          <Col xs={12} sm={12} md={5} lg={5}>
            <h2 styleName='faq-h2'>
              Frequently asked questions
            </h2>
          </Col>
          <Col xs={12} sm={12} md={7} lg={7}>
            {
              this.state.faqs.map((e, i) => {
                return <div styleName='tsp-faq-item' key={'tsp-faq-item'+i}>
                  <div
                    onClick={()=>{
                      const newOpenState = this.state.open
                      newOpenState[i] = (!newOpenState[i] || newOpenState[i] === null)
                      this.setState({ open: newOpenState })
                    }}
                    styleName='tsp-faq-q'
                  >
                    <h3>{e[0]}</h3>
                    <LinkIcon nospace faclass={this.state.open[i] ?
                                                 'fa-angle-up' :
                                                 'fa-angle-down'} />
                  </div>
                  <SlideDown>
                    {
                      this.state.open[i] ?
                        <div styleName='tsp-faq-a'>
                          <p>{e[1]}</p>
                        </div> :
                        null
                    }
                  </SlideDown>
                </div>
              })
            }
          </Col>
        </Row>
      </ContainerDivs>
    </div>
  }
}


@connect(
  state => ({
    result: state.tspShareClass.result,
    searching: state.tspShareClass.loading,
    searched: state.tspShareClass.loaded,
    error: state.tspShareClass.error,
  }),
  searchActions)

@CSSModules(Styles, { allowMultiple: true })
export default class TspLanding extends Component {
  static propTypes = {
    searching: PropTypes.bool,
    searched: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.array,
  }

  static contextTypes =  {
    router: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      tspByType: this.defaultTspByType(),
      chartFilter: 'og'
    }
  }

  componentWillMount() {
    // if (typeof window !== 'undefined') {
    //   window.scrollTo(0,0)
    // }
    this.props.tspShareClasses()
  }

  componentWillReceiveProps(props) {
    // split into L, Ind -> (E, B)
    const tspByType = this.defaultTspByType()

    props.result.forEach((r)=>{
      if (r.fund_legal_name.slice(0,5) === 'TSP L') {
        tspByType.L.push(r)
      } else {
        tspByType.E.push(r)
      }
    })

    tspByType.L = tspByType.L.sort((a, b) => { return b.fund_legal_name.localeCompare(a.fund_legal_name) })
    tspByType.E = tspByType.E.sort((a, b) => { return a.net_assets - b.net_assets })

    tspByType.L.push({'fund_legal_name': 'TSP L 2025'})
    tspByType.L.push({'fund_legal_name': 'L Income'})

    this.setState({
      tspByType: tspByType
    })
  }

  defaultTspByType(){
    return {
      'L': [],
      'E': [],
      'B': []
    }
  }

  roundToBillions(x, full=true, letter=false){
    const ONE_BILLION = 1000000000
    const ONE_MILLION = 1000000
    const mult = full ? ONE_BILLION : 1
    if (x > ONE_BILLION) {
      return `$${((x / ONE_BILLION).toFixed(1) * mult).toLocaleString()}${letter ? 'B' : ''}`
    } else {
      return `$${((x / ONE_MILLION).toFixed(0) * mult).toLocaleString()}${letter ? 'M' : ''}`
    }
  }

  render() {
    const title = 'Thrift Savings Plan'
    const desc = 'The Federal government\'s retirement plan has billions invested in fossil fuels putting the climate at risk.'
    const url = config.domain + config.routes.tspLanding

    const socialShareUrl =  config.domain+imageSocialShare.replace(/.*dist/,'/dist')

    //
    return (
      <div styleName='page'>
        {container.helmet(title, desc, url)}

        <Helmet meta={[
          {property: 'og:image', content: socialShareUrl},
          {property: 'twitter:image', content: socialShareUrl},
        ]}/>


        { /* PAGE HEADER */ }
        <TspLede roundToBillions={this.roundToBillions} />


        { /* PIE CHART */ }
        <TspPieChart roundToBillions={this.roundToBillions} />


        { /* BANNER */ }
        <TspBanner />


        { /* TOP 10 BAR CHARTS */ }
        <TspCompanyCharts roundToBillions={this.roundToBillions} />
        <TspStarsBar />


        { /* TSP BLACKROCK STATE STREET PANEL */ }
        <TspAssetManagers />
        <TspStarsBar />


        { /* TSP FUND RESULTS */ }
        <div styleName='tsp-nav-wrap'>
          { this.props.searching || !this.props.result || this.props.result.length === 0 ?
              <div styleName='tsp-nav-loader-wrap'>
                <Loader
                  options={{ scale: 0.70, top: '2rem' }}
                  loaded={ false }
                />
              </div> :
              <ContainerDivs>
                <h2 styleName='tsp-nav-h2'>
                  Select a Thrift Savings Plan (TSP) fund below to see
                  its fossil fuel investments:
                </h2>

                <Row>
                  <Col xs={12} sm={6}>
                    <div styleName='tsp-nav-col'>
                      <h3 styleName='tsp-nav-col-label'>
                        LIFECYCLE FUNDS
                      </h3>

                      <p styleName='tsp-nav-col-section-label'>
                        Target date funds
                      </p>

                      {
                        this.state.tspByType.L.map((e,i) => {
                          return <TspFundItem key={'l-funds-'+i} fund={e} />
                        })
                      }
                    </div>

                  </Col>
                  <Col xs={12} sm={6}>
                    <div styleName='tsp-nav-col'>
                      <XsBr/>
                      <XsBr/>
                      <h3 styleName='tsp-nav-col-label'>
                        INDIVIDUAL FUNDS
                      </h3>
                      <p styleName='tsp-nav-col-section-label'>
                        Equity funds
                      </p>

                      {
                        this.state.tspByType.E.map((e,i) => {
                          return <TspFundItem key={'e-funds-'+i} fund={e} />
                        })
                      }

                      <br/>
                      <br/>

                      <p styleName='tsp-nav-col-section-label'>
                        Fixed income/stable value funds
                      </p>

                      {
                        [
                          {'fund_legal_name': 'TSP G Fund'},
                          {'fund_legal_name': 'TSP F Fund'},
                        ].map((e,i) => {
                          return <TspFundItem key={'b-funds-'+i} fund={e} />
                        })
                      }
                    </div>

                  </Col>
                </Row>

                <div styleName='tsp-nav-disclaimer'>
                  <div styleName='tsp-nav-disclaimer-icon'>
                    <LinkIcon nospace faclass='fa-info-circle' />
                  </div>
                  <p>
                    The TSP offers five core funds: three equity funds (the
                    C, S, and I funds), and
                    two bond funds (the F and G funds).

                    It also offers a sequence of 10 target date funds,
                    called the L funds,
                    which themselves invest in the core individual funds.

                    For each of these funds, we've measured the fund exposure
                    to fossil fuel investments.

                    We show the percentage of fund assets in fossil fuel
                    stocks, and we show a fossil fuel letter grade
                    based on that exposure.

                    Click any fund to see more detailed results.
                  </p>
                </div>

                <p styleName='tsp-bond-disclaimer'>
                  * Bond fund results are currently unavailable. Check back soon.
                </p>
              </ContainerDivs>
          }
        </div>


        { /* TSP RECOMMENDATIONS */ }
        <TspRecommendations />


        { /* SOLUTIONS, TAKE ACTION */ }
        <TspSolutionsTakeAction />


        { /* TSP FAQS */ }
        <TspFAQs />


      </div>
    )
  }
}
